import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rciq_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rciq_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("rciq_user", JSON.stringify(r.data)); })
      .catch(() => {
        localStorage.removeItem("rciq_token");
        localStorage.removeItem("rciq_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("rciq_token", data.token);
    localStorage.setItem("rciq_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const refreshMe = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("rciq_user", JSON.stringify(data));
    return data;
  };

  const logout = () => {
    localStorage.removeItem("rciq_token");
    localStorage.removeItem("rciq_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refreshMe }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
